// Contains general quad functions to be used by withQuadTransformers.
const quadTable = {
	blueLabel: (w, h) => [
		0,
		0,
		w,
		(-0.1 / 3) * h,
		w - (0.1 / 2) * w,
		h,
		0.1 * w,
		h - (0.1 / 3) * h,
	],
	dropdown: (w, h) => [
		0,
		-0.05 * h,
		w,
		-0.05 * h,
		w + (0.05 / 2) * w,
		h,
		-0.05 * w,
		h,
	],
	// activityTab: (w, h) => [0, 0, w, 0, w + 0.01 * w, h, -0.005 * w, 0.005 * w + h],
	tabButton: (w, h) => [-0.05 * h, 0, w + 0.05 * h, 0, w, h, 0, h + 0.05 * h],
	sideMenu: (w, h) => [-0.05 * w, -0.01 * h, w, 0, w, h, 0, h + 0.02 * h],
	pullOut: (w, h) => [0, 0.1 * h, w - 0.05 * w, 0, w, h, 0, h - 0.05 * h],
	closeButton: (w, h) => [0, 0, w, 0.05 * h, w - 0.2 * w, h, 0, h - 0.1 * h],
	labDescription: (w, h) => [0, 0, w, 0, w - 0.015 * w, h, w * 0.02, h],
	colorPalette: (w, h) => [0, 0, w, 0, w - 0.005 * w, h, w * 0.001, h],
	lessonPrompt: (w, h) => [0, 0, w, 0, w - 0.05 * w, h, w * 0.02, h],
};

// Quad function sets

// For beast items in beast parts shop
const getBeastItemSet = function(num) {
	// Nudge amounts
	const xs = 0.03;
	const ys = 0.02;
	const map = [
		{
			box: (w, h) => [0, 0, w, 0, w - xs * w, h - ys * h, 0, h],
			price: (w, h) => [-2 * xs * w, 2 * ys * h, w, 0, w, h, 0, h],
		},
		{
			box: (w, h) => [0, 0, w, 0, w, h, -xs * w, h - ys * h],
			price: (w, h) => [-2 * xs * w, 2 * ys * h, w, 0, w, h, 0, h],
		},
		{
			box: (w, h) => [0, 0, w - xs * w, -ys * h, w, h, 0, h],
			price: (w, h) => [0, 0, w, 0, w + 2 * xs * w, h + 2 * ys * h, 0, h],
		},
		{
			box: (w, h) => [-xs * w, -ys * h, w, 0, w, h, 0, h],
			price: (w, h) => [0, 0, w, 0, w + 2 * xs * w, h + 2 * ys * h, 0, h],
		},
	];
	return map[num];
};

// For beast builder layering controls
const getBeastBuilderLayerSet = function() {
	return {
		topdown: (w, h) => [0.03 * w, 0, w, 0, w, h - 0.05 * h, 0, h],
		bottomup: (w, h) => [0, 0, w, 0, w, h - 0.05 * h, 0.08, h],
	};
};

// For blue labels
const getBlueLabelSet = function(num) {
	const map = [
		(w, h) => [0, 0, w, (0.1 / 3) * h, w - 0.1 * w, h, (0.1 / 2) * w, h],
		(w, h) => [
			(0.1 / 3) * w,
			0,
			w - (0.1 / 2) * w,
			0,
			w,
			h - (0.1 / 3) * h,
			0,
			h,
		],
		(w, h) => [0, 0, w, 0, w - (0.1 / 2) * w, h, 0.1 * w, h + (0.1 / 3) * h],
	];
	return map[num];
};

// Items inside dropdown
const getDropdownItemsSet = function(num) {
	const map = [
		(w, h) => [0, 0, w, 0, w - 0.05 * w, h, (0.05 / 2) * w, h],
		(w, h) => [(0.05 / 3) * w, 0, w - (0.05 / 2) * w, 0, w, h, 0, h],
		(w, h) => [0, 0, w, 0, w - (0.05 / 2) * w, h, 0.05 * w, h],
	];
	return map[num];
};

// Block Links in Library
const getLibraryLessonLinkSet = function(num) {
	const map = [
		(w, h) => [0, 0, w, 0, w - 0.05 * w, h, (0.05 / 2) * w, h],
		(w, h) => [(0.05 / 3) * w, 0, w - (0.05 / 2) * w, 0, w, h, 0, h],
		(w, h) => [0, 0, w, 0, w - (0.05 / 2) * w, h, 0.05 * w, h],
	];
	return map[num];
};

// Profile star legend
const getBarLegendSet = function() {
	return {
		first: (w, h) => [-0.15 * h, 0, w + 0.1 * h, 0, w + 0.1 * h, h, 0.1 * h, h],
		last: (w, h) => [-0.1 * h, 0, w + 0.05 * h, 0, w, h, -0.1 * h, h],
	};
};

// Profile panels header and body
const getProfileSet = function() {
	return {
		head: (w, h) => [0, 0, w, 0.1 * h, w, h, 0, h],
		body: (w, h) => [0, 0, w, 0, w, h + 0.02 * h, 0, h],
	};
};

const getChapterModalSet = function(grade) {
	const dx = 0.03;
	const dy = 0.15;
	let set = {};
	switch (parseInt(grade)) {
		case 1:
			set = {
				head: (w, h) => [
					-dx * w,
					dy * h,
					w + dx * w,
					0,
					w + dx * 0.9 * w,
					h,
					-(dx * 0.9) * w,
					h,
				],
				body: (w, h) => [
					-(dx * 0.9) * w,
					0,
					w + dx * 0.9 * w,
					0,
					w,
					h + (dy / 4) * h,
					0,
					h + (dy / 3) * h,
				],
			};
			break;
		case 2:
			set = {
				head: (w, h) => [
					dx * w,
					0,
					w - dx * w,
					dy * h,
					w - dx * 0.9 * w,
					h,
					dx * 0.9 * w,
					h,
				],
				body: (w, h) => [
					dx * 0.9 * w,
					0,
					w - dx * 0.9 * w,
					0,
					w,
					h + (dy / 3) * h,
					0,
					h + (dy / 2) * h,
				],
			};
			break;
		case 3:
			set = {
				head: (w, h) => [
					-dx * w,
					dy * h,
					w + dx * w,
					0,
					w + dx * 0.9 * w,
					h,
					-(dx * 0.9) * w,
					h,
				],
				body: (w, h) => [
					-(dx * 0.9) * w,
					0,
					w + dx * 0.9 * w,
					0,
					w,
					h + (dy / 4) * h,
					0,
					h + (dy / 3) * h,
				],
			};
			break;
		case 4:
			set = {
				head: (w, h) => [
					dx * w,
					0,
					w - dx * w,
					dy * h,
					w - dx * 0.9 * w,
					h,
					dx * 0.9 * w,
					h,
				],
				body: (w, h) => [
					dx * 0.9 * w,
					0,
					w - dx * 0.9 * w,
					0,
					w,
					h + (dy / 8) * h,
					0,
					h + (dy / 4) * h,
				],
			};
			break;
		case 5:
			set = {
				head: (w, h) => [
					-dx * w,
					dy * h,
					w + dx * w,
					0,
					w + dx * 0.9 * w,
					h,
					-(dx * 0.9) * w,
					h,
				],
				body: (w, h) => [
					-(dx * 0.9) * w,
					0,
					w + dx * 0.9 * w,
					0,
					w,
					h + (dy / 4) * h,
					0,
					h + (dy / 8) * h,
				],
			};
			break;
	}
	return set;
};

// Profile block type graph beast name labels
const getBeastNameSet = function(beast) {
	const set = getProfileSet();
	const map = {
		q: set.head,
		grok: set.body,
		fiona: set.head,
		kraken: set.body,
		rote: set.head,
		ms_levans: set.body,
	};
	return map[beast];
};

// Profile wart. Currently unused.
const getWart = function() {
	return {
		wart: (w, h) => [0, 0, w, 0, w, h, 0, h + 0.02 * h],
		body: (w, h) => [0, 0, w, 0, w, h, 0, h + 0.01 * w],
	};
};

//Block button set
const getBlockButtonSet = function(num, smaller) {
	const map = {
		1: (w, h) => [
			0.016 * w,
			0.082 * h,
			1.0 * w,
			0.027 * h,
			0.966 * w,
			0.999 * h,
			0.045 * w,
			0.975 * h,
		],
		2: (w, h) => [
			0.013 * w,
			0.058 * h,
			0.971 * w,
			0.036 * h,
			0.991 * w,
			0.992 * h,
			0.025 * w,
			0.981 * h,
		],
		3: (w, h) => [
			0.013 * w,
			0.037 * h,
			0.971 * w,
			0.094 * h,
			1.0 * w,
			0.97 * h,
			0.093 * w,
			0.998 * h,
		],
	};
	// Less slant-y quads for smaller blocks
	const mapSmaller = {
		1: (w, h) => [
			0.016 * w,
			0.062 * h,
			1.0 * w,
			0.027 * h,
			0.966 * w,
			0.999 * h,
			0.045 * w,
			0.975 * h,
		],
		2: map["2"],
		3: (w, h) => [
			0.013 * w,
			0.037 * h,
			0.971 * w,
			0.064 * h,
			1.0 * w,
			0.97 * h,
			0.093 * w,
			0.998 * h,
		],
	};
	if (smaller) {
		return mapSmaller[num];
	} else {
		return map[num];
	}
};

// Given an 8 element array returned from a quad function, return a shrunken
// version. topR, rightR, bottomR, leftR are 0 to 1 values. 0 means don't
// shrink that edge, 0.1 means move the endpoints of that edge inward 10%, etc.
const shrinkQuad = function(qv, topR, rightR, bottomR, leftR) {
	// i is the qv index to alter, horizR is either leftR or rightR, and vertR is
	// either topR or bottomR.
	const makeCoord = (i, horizR, vertR) => {
		return (
			qv[i] * (1 - horizR) * (1 - vertR) +
			qv[i ^ 2] * horizR * (1 - vertR) + // Horizontally adjacent endpoint
			qv[i ^ 6] * (1 - horizR) * vertR + // Vertically adjacent endpoint
			qv[i ^ 4] * horizR * vertR
		); // Opposite endpoint
	};
	return [
		makeCoord(0, leftR, topR),
		makeCoord(1, leftR, topR),
		makeCoord(2, rightR, topR),
		makeCoord(3, rightR, topR),
		makeCoord(4, rightR, bottomR),
		makeCoord(5, rightR, bottomR),
		makeCoord(6, leftR, bottomR),
		makeCoord(7, leftR, bottomR),
	];
};

// Return the (w, h) function to pass to the quad component for each cell of a
// uniform-cell-size table which has normal rows but slanted column boundaries.
// x and y are 0-indexed. spacing is the border spacing of the table in pixels.
// slants is an array of length xSize+1, giving the amount that the column
// boundary slants right at the top as a coefficient on the cell width.
const computeSlantTable = function(slants, xSize, ySize, x, y, spacing) {
	const tlX = (1 - (2 * y) / ySize) * slants[x];
	const trX = 1 + (1 - (2 * y) / ySize) * slants[x + 1];
	const blX = (1 - (2 * (y + 1)) / ySize) * slants[x];
	const brX = 1 + (1 - (2 * (y + 1)) / ySize) * slants[x + 1];
	return (w, h) => [
		(spacing / 2) * (1 - tlX) + w * tlX,
		0,
		(-spacing / 2) * (1 - trX) + w * trX,
		0,
		(-spacing / 2) * (1 - brX) + w * brX,
		h,
		(spacing / 2) * (1 - blX) + w * blX,
		h,
	];
};

// Library book chapters
const getBookChapterSet = function(num) {
	const offsets = [0.01, 0.006, 0.013, 0.015];
	const offset = offsets[num];
	return (w, h) => [
		offset * w,
		offset * 3 * h,
		w,
		offset * 2 * h,
		w - offset * w,
		h - offset * h,
		offset * 3 * w,
		h - offset * h,
	];
};

const getBookMenuSectionQuad = function(i, isFirst, isLast) {
	const d = 0.013;
	if (isFirst) {
		return (w, h) => [0, 0, w, 0, w, h - d * w, 0, h + d * w];
	} else if (isLast) {
		if (i % 2) {
			return (w, h) => [0, d * w, w, -d * w, w, h, 0, h];
		} else {
			return (w, h) => [0, -d * w, w, d * w, w, h, 0, h];
		}
	} else if (i % 2) {
		return (w, h) => [0, d * w, w, -d * w, w, h + d * w, 0, h - d * w];
	} else {
		return (w, h) => [0, -d * w, w, d * w, w, h + -d * w, 0, h + d * w];
	}
};

// Video quads
const getVideoSet = function(num) {
	const offsets = [0.01, 0.006, 0.013, 0.015];
	const offset = offsets[num];
	return (w, h) => [
		offset * w,
		offset * 3 * h,
		w,
		offset * 2 * h,
		w - offset * w,
		h - offset * h,
		offset * 3 * w,
		h - offset * h,
	];
};

const getLeaderboardsSet = function() {
	return {
		avatarModalUsername: (w, h) => [
			0,
			0,
			w,
			(-0.1 / 3) * h,
			w - 0.03 * w,
			h,
			0.03 * w,
			h - (0.1 / 3) * h,
		],
	};
};

module.exports = {
	quadTable,
	getBeastItemSet,
	getLibraryLessonLinkSet,
	getBlueLabelSet,
	getBeastBuilderLayerSet,
	getDropdownItemsSet,
	getBarLegendSet,
	getProfileSet,
	getBeastNameSet,
	getWart,
	getBlockButtonSet,
	getBookChapterSet,
	shrinkQuad,
	computeSlantTable,
	getBookMenuSectionQuad,
	getChapterModalSet,
	getVideoSet,
	getLeaderboardsSet,
};
